import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import { useEffect, useState } from 'react';

export const POINTOFINTEREST_LAYER_ID = 'pointOfInterestLayer';

const ICONS = {
    'Public School': require('../../../assets/school.png'),
    'Healthcare Facility': require('../../../assets/hospital.png'),
    // 'Senior Living': require('../../../assets/seniorLiving.png'),
    'Others': require('../../../assets/others.png'),
};

const layerConfig = {
  title: 'Points of Interest',
};

function PointOfInterestLayer() {
  const dispatch = useDispatch();
  const { pointOfInterestLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, pointOfInterestLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });
 const viewState = useSelector((state) => state.carto.viewState);

  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    if (viewState.zoom > 12) {
      setIsShow(true);
    } else setIsShow(false);
  }, [viewState]);

  if (pointOfInterestLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: POINTOFINTEREST_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: isShow ? pointOfInterestLayer.visible : false,
      opacity: pointOfInterestLayer.opacity,

      pointType: 'icon',
      getIcon: (d) => {
        if (d.properties.point_of_interest === 'Public School')
          return {
            url: ICONS['Public School'],
            width: 128,
            height: 128,
            anchorY: 128,
          };
        if (d.properties.point_of_interest === 'Healthcare Facility')
          return {
            url: ICONS['Healthcare Facility'],
            width: 128,
            height: 128,
            anchorY: 128,
          };
        // if (d.properties.point_of_interest === 'Senior Living')
        //   return {
        //     url: ICONS['Senior Living'],
        //     width: 128,
        //     height: 128,
        //     anchorY: 128,
        //   };
        return {
          url: ICONS['Others'],
          width: 128,
          height: 128,
          anchorY: 128,
        };
      },
      getIconSize: () => 12,
      iconSizeUnits: 'pixels',
      iconSizeScale: 2,
      iconBillboard: true,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: POINTOFINTEREST_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              title: 'Point of Interest',
              //includeColumns: ['Facility_Type', 'Facility_Name'], 
            }),
          };
        }
      },
    });
  }
}

export default PointOfInterestLayer;
